
import { Component, Prop, Vue } from 'vue-property-decorator';
import api from '@/api';
import DateTimePicker from '@/components/DateTimePicker.vue';
import Util from '@/utils/util';
import Swal from 'sweetalert2';

const { pointVoucher } = api;

interface statusViewModel {
  text: string,
  value: number,
}

@Component({
  components: { DateTimePicker },
})
export default class SwapInPointVoucherEdit extends Vue {
  @Prop({}) private id!: string;

  private loading: boolean = false;

  private valid: boolean = false;

  private statusSelect: Array<statusViewModel> = [
    { text: '未啟用', value: 0 },
    { text: '啟用', value: 1 },
    { text: '已兌換', value: 2 },
    { text: '已作廢', value: 3 },
    { text: '已過期', value: 4 },
    { text: '已鎖定', value: 5 },
  ];

  private data = {
    voucherNo: '',
    itemName: '',
    pointValue: 0,
    status: 100,
  }

  private get formStatusSelect() {
    switch (this.data.status) {
      case 0: {
        return [
          { text: '啟用', value: 1 },
        ];
      }
      case 1: {
        return [
          { text: '兌換', value: 2 },
          { text: '作廢', value: 3 },
          { text: '過期', value: 4 },
          { text: '鎖定', value: 5 },
        ];
      }
      case 2: {
        return [
          { text: '取消兌換', value: 1 },
        ];
      }
      case 3: {
        return [
          { text: '取消作廢', value: 1 },
        ];
      }
      case 4: {
        return [
          { text: '取消過期', value: 1 },
        ];
      }
      case 5: {
        return [
          { text: '取消鎖定', value: 1 },
        ];
      }
      default: {
        return this.statusSelect;
      }
    }
  }

  private form = {
    status: undefined,
  }

  private rules = {
    status: [this.requiredRule('狀態')],
  }

  private requiredRule(column: string) {
    return (v: any) => !Util.isNullOrEmpty(v) || `${column} 為必填`;
  }

  private async cancel() {
    await this.$router.back();
  }

  private async mounted() {
    const { data } = await pointVoucher.get(this.id);
    this.data = data;
  }

  private async submit() {
    const form = this.$refs.form as any as { validate: () => boolean };
    if (form.validate()) {
      const { status } = await pointVoucher.changeStatus(this.id, this.form.status);
      if (status === 1) {
        await Swal.fire({ icon: 'success', title: '修改成功' });
        this.$router.back();
      }
    }
  }
}
